export class DataListHook {
    data: any[]=[];
    columns: any[]=[]
}